import {store} from "../App";
import {getFromHub} from "./networkActions";
import {sections} from "../utils/questionnaireUtils";

export function fetchSectionsFromHub(bookingType, category) {
    getFromHub(`precruise/config/${bookingType}`, (response)=>setSections(response, category))

}

function setSections(response, category = "travelInfo") {
    // loop over response and filter out any of the sections that are not part of travelInfo
    // replace the info from the hub with the frontend labels until the hub is ready to provide the labels in the response
    // default the labels to "Unknown" for unknown sections
    // sort the sections to match the order defined in the frontend sections array, placing new sections (if any) at the end

    const order = sections.map(s => s.hubId);
    const filteredSections = response.precruiseConfiguration
        .filter(el => el.category === category && el.questionnaire !== "cardDetails")
        .map(hubEl =>
            sections.find(section => section.hubId === hubEl.questionnaire) ||
            {hubId: hubEl.questionnaire, label: "Unknown", reviewLabel: "Unknown", preFormLabel: "Unknown"}
        ).sort((a, b) => {
            const indexA = order.indexOf(a.hubId);
            const indexB = order.indexOf(b.hubId);
            return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
        });


    store.dispatch({
        type: "SET_SECTIONS",
        sections: filteredSections,
    });
}